import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=5bac053c&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=5bac053c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac053c",
  null
  
)

export default component.exports